import React from 'react';

const sanitizeHeaderText = (value) => {
  return String(value ?? '')
    .replace(/\u00e2\u0080\u00a2/g, ' ')
    .replace(/\u2022/g, ' ')
    .replace(/[\u0000-\u001f\u0080-\u009f\uFFFD]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

const textValue = (value, fallback = 'N/A') => {
  const text = sanitizeHeaderText(value);
  return text || fallback;
};

const SavedPayslipHeader = ({ record }) => {
  const companyLogoSrc = `${process.env.PUBLIC_URL}/isource_logo.png`;

  return (
    <div className="mb-4 pb-3 border-b border-gray-300">
      <div className="grid grid-cols-[112px_1fr] gap-x-4 gap-y-2 items-start">
        <img
          src={companyLogoSrc}
          alt="iSOURCE Logo"
          className="h-28 w-28 object-contain"
        />
        <div className="text-gray-900">
          <div className="font-bold">
            ISOURCE ASIA BUSINESS SOLUTIONS CORPORATION
          </div>
          <div className="text-sm leading-tight text-gray-700">
            <div>Imelda Bldg, 497-B Calbayog Street,</div>
            <div>Brgy. Hightway Hills, Mandaluyong City</div>
            <div>Vat Reg. TIN: 010-611-699-000</div>
          </div>
        </div>

        <div />
        <div className="text-sm text-gray-900">
          <div className="font-semibold">{textValue(record?.employee_name)}</div>
          <div className="text-xs text-gray-700">Branch: {textValue(record?.branch)}</div>
          <div className="flex justify-between mt-2 gap-3">
            <div><span className="font-semibold">SSS:</span> {textValue(record?.sss_number)}</div>
            <div><span className="font-semibold">TIN:</span> {textValue(record?.tin_number)}</div>
          </div>
          <div className="flex justify-between gap-3">
            <div><span className="font-semibold">PhilHealth:</span> {textValue(record?.phic_number)}</div>
            <div><span className="font-semibold">Pag-IBIG:</span> {textValue(record?.hdmf_number)}</div>
          </div>
          <div className="mt-2">
            <span className="font-semibold">Payroll Period:</span> {textValue(record?.payroll_period)}
          </div>
          <div>
            <span className="font-semibold">Payroll Range:</span> {textValue(record?.start_date)} to {textValue(record?.end_date)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SavedPayslipHeader;
